import { config } from "@/config";
export class NotaCreditoService {
    static async getAll() {
        const response = await fetch(`${config.API_URL}/api/NotaCredito`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error fetching NotaCredito");
        return response.json();
    }
    static async getById(id) {
        const response = await fetch(`${config.API_URL}/api/NotaCredito/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error fetching NotaCredito by id");
        return response.json();
    }
    static async create(data) {
        const response = await fetch(`${config.API_URL}/api/NotaCredito`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok)
            throw new Error("Error creating NotaCredito");
        return response.json();
    }
    static async confirmarReingreso(id) {
        const response = await fetch(`${config.API_URL}/api/NotaCredito/${id}/confirmar-reingreso`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error confirmando reingreso");
        return response.json();
    }
}
